import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-smash-card-expansion',
  templateUrl: './smash-card-expansion.component.html',
  styleUrls: ['./smash-card-expansion.component.scss']
})
export class SmashCardExpansionComponent implements OnInit {

  @Output() onToggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  toggled = false;

  constructor() { }

  ngOnInit(): void {
  }

  toggle() {
    this.toggled = !this.toggled;
    this.onToggle.emit(this.toggled);
  }

}
